import React from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom

const ReportDataTable = () => {
  return (
    <div>
      <h5 className="mb-3">
        <Link to="/esic-pf" style={{ textDecoration: "none", color: "blue" }}>
          Esic & PF Report
        </Link>
      </h5>
    </div>
  );
};

export default ReportDataTable;
